'use client';

import { WorkspaceInfoTooltip } from './workspace-info-tooltip';
import type { WorkspaceUploadRequirements } from './workspace-upload-requirements';

export function WorkspaceUploadRequirementsTooltip({
  ariaLabel,
  requirements,
}: {
  ariaLabel: string;
  requirements: WorkspaceUploadRequirements;
}) {
  return (
    <WorkspaceInfoTooltip
      ariaLabel={ariaLabel}
      contentClassName="px-3.5 py-3"
      content={
        <div className="w-[17rem] max-w-[calc(100vw-2rem)] text-left">
          {requirements.sections.map((section, index) => (
            <section
              key={section.id}
              className={
                index === 0 ? '' : 'mt-3 border-t border-border/60 pt-3'
              }
            >
              <div className="cms-block-workspace-workspace-1-workspace-upload-requirements-tooltip__title text-popover-foreground">
                {section.title}
              </div>

              {section.summary.length > 0 ? (
                <div className="mt-0.5 text-xs leading-5 text-popover-foreground/65">
                  {section.summary.join(' · ')}
                </div>
              ) : null}

              {section.details.length > 0 ? (
                <div className="mt-1 text-xs leading-5 text-popover-foreground/85">
                  {section.details.join(' · ')}
                </div>
              ) : null}

              {section.tiers?.length ? (
                <div className="mt-1.5 grid grid-cols-[auto_1fr] gap-x-3 gap-y-1 text-xs leading-5">
                  {section.tiers.map((tier) => (
                    <div key={tier.label} className="contents">
                      <span className="font-medium text-popover-foreground/60">
                        {tier.label}
                      </span>
                      <span className="text-popover-foreground">
                        {tier.value}
                      </span>
                    </div>
                  ))}
                </div>
              ) : null}
            </section>
          ))}
        </div>
      }
    />
  );
}
